<template>
  <div class="append-box">
    <v-mask
      style="background: ragb(0, 0, 0, 0.6)"
      @touchmove="gtouchmove"
      @click="handleClose"
    ></v-mask>
    <div class="dialog-notice-box">
      <div
        v-bind:class="{
          'animated baisonFadeInDown': true,
          'ani-dialog-notice-box': true,
          baisonFadeInUp: fadeOut,
        }"
      >
        <div class="tag-list">
          <div
            v-bind:class="{
              'tag-item tag-item-act': true,
              selected: tabIndex == 0,
            }"
            @click="handleChangeTab(0)"
            v-clickMusic
          ></div>
          <div
            v-bind:class="{
              'tag-item tag-item-notice': true,
              selected: tabIndex == 1,
            }"
            @click="handleChangeTab(1)"
            v-clickMusic
          ></div>
        </div>
        <div class="tag-menu-box" ref="tagMenuBox">
          <ul class="tag-menu-list">
            <li
              v-for="(item, i) in tabMenuData"
              v-bind:class="{
                'tag-menu-item': true,
                notice: tabIndex == 1,
                selected: item.is_default == 1,
              }"
              v-bind:key="i"
              @click="handleChangeTagMenu(item)"
              v-clickMusic
            >
              <div class="item-content">{{ item.title | filterTitle }}</div>
            </li>
          </ul>
        </div>
        <div class="content-wrapper" ref="contentWrapper">
          <div class="content" v-if="content.pic_url">
            <img
              :src="content.pic_url"
              @click="handleJump(content)"
              v-clickMusic
            />
          </div>
          <div
            class="content"
            @click="handleTextJump($event, content)"
            v-clickMusic
            v-html="content.content"
            v-else
          ></div>
        </div>
        <btnClose
          v-bind:class="{ 'close-pop-message': true }"
          v-clickMusic
          @close="handleClose"
        ></btnClose>
      </div>
    </div>
  </div>
</template>

<script>
import vmask from "@/components/mask.vue";
import BScroll from "@better-scroll/core";
import btnClose from "@/components/btnClose.vue";
import { openUrl } from "@/utils";
import store from "@/store/index";
export default {
  name: "dialogNoticeStyle2",
  components: {
    "v-mask": vmask,
    btnClose,
  },
  data() {
    return {
      userKey: "",
      gameID: "",
      theme: store.state.app.theme,
      tabIndex: -1,
      fadeOut: false,
      tabMenuIndex: 1,
      data: [],
      tabMenuData: [],
      content: {},
    };
  },
  mounted() {
    const scrollMenu = new BScroll(this.$refs.tagMenuBox, {
      click: true,
    });
    const scrollContent = new BScroll(this.$refs.contentWrapper, {
      click: true,
    });
    // this.data = [
    //   {
    //     is_default: 1,
    //     type: "2",
    //     child: [
    //       {
    //         type: "2",
    //         title: "\u606d\u559c\u53d1\u8d22",
    //         content: "123123321312312",
    //         is_default: 1,
    //         jump_url: "https://do.baison-poker.com/newyearvideo",
    //         pic_url: "",
    //         alert_type: "1",
    //       },
    //       {
    //         type: "2",
    //         title: "1231231231",
    //         content: "",
    //         is_default: 0,
    //         jump_url: "https://do.baison-poker.com/newyearvideo",
    //         pic_url: "https://upload.yly0707.com/public/image/a59ebf5408.png",
    //         alert_type: "1",
    //       },
    //       {
    //         type: "1",
    //         title: "\u606d\u559c\u53d1\u8d22",
    //         content: "",
    //         is_default: 0,
    //         jump_url: "https://do.baison-poker.com/newyearvideo",
    //         pic_url: "https://upload.yly0707.com/public/image/a59ebf5408.png",
    //         alert_type: "1",
    //       },
    //       {
    //         type: "1",
    //         title: "1231231231",
    //         content: "",
    //         is_default: 0,
    //         jump_url: "https://do.baison-poker.com/newyearvideo",
    //         pic_url: "https://upload.yly0707.com/public/image/a59ebf5408.png",
    //         alert_type: "1",
    //       },
    //     ],
    //   },
    //   {
    //     is_default: 0,
    //     type: "1",
    //     child: [
    //       {
    //         type: "2",
    //         title: "\u606d\u559c\u53d1\u8d22",
    //         content: "",
    //         is_default: 1,
    //         jump_url: "https://do.baison-poker.com/newyearvideo",
    //         pic_url: "https://upload.yly0707.com/public/image/a59ebf5408.png",
    //         alert_type: "1",
    //       },
    //       {
    //         type: "2",
    //         title: "1231231231",
    //         content: "",
    //         is_default: 0,
    //         jump_url: "https://do.baison-poker.com/newyearvideo",
    //         pic_url: "https://upload.yly0707.com/public/image/a59ebf5408.png",
    //         alert_type: "1",
    //       },
    //       {
    //         type: "1",
    //         title: "\u606d\u559c\u53d1\u8d22",
    //         content: "",
    //         is_default: 0,
    //         jump_url: "https://do.baison-poker.com/newyearvideo",
    //         pic_url: "https://upload.yly0707.com/public/image/a59ebf5408.png",
    //         alert_type: "1",
    //       },
    //       {
    //         type: "1",
    //         title: "1231231231",
    //         content: "",
    //         is_default: 0,
    //         jump_url: "https://do.baison-poker.com/newyearvideo",
    //         pic_url: "https://upload.yly0707.com/public/image/a59ebf5408.png",
    //         alert_type: "1",
    //       },
    //     ],
    //   },
    // ];
    this.initData();
    this.$nextTick(() => {
      scrollMenu.refresh();
      scrollContent.refresh();
    });
  },
  filters: {
    filterTitle: function (value) {
      if (!value) return "";
      // if (String(value).length > 4) {
      //   return String(value).substr(0, 4);
      // } else {
      //   return value;
      // }
      return value;
    },
  },
  watch: {
    tabIndex(val) {
      this.renderDataByIndex(val);
    },
    tabMenuData() {
      this.changeContent();
    },
  },
  methods: {
    initData() {
      const actData = this.getActData();
      this.tabIndex = actData.is_default == 1 ? 0 : 1;
    },
    renderDataByIndex(index) {
      const actData = this.getActData(),
        noticeData = this.getNoticeData();
      if (index == 0) {
        this.tabMenuData = this.supplementaryData(actData.child);
      } else {
        this.tabMenuData = this.supplementaryData(noticeData.child);
      }
    },
    supplementaryData(arr) {
      if (arr.length > 0) {
        if (arr.findIndex((child) => child.is_default == 1) == -1) {
          arr[0].is_default = 1;
        }
        return arr;
      } else {
        return [];
      }
    },
    getActData() {
      return this.getDatByType(2);
    },
    getNoticeData() {
      return this.getDatByType(1);
    },
    getDatByType(type) {
      let data = {
        child: [],
      };
      for (let i = 0; i < this.data.length; i++) {
        if (parseInt(this.data[i].type) == type) {
          data = this.data[i];
          break;
        }
      }
      return data;
    },
    gtouchmove(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    remove() {
      this.$el.parentNode.removeChild(this.$el);
      this.$destroy(true);
      this.$newYearScroll(this.userKey, this.gameID);
    },
    handleClose() {
      this.fadeOut = true;
      setTimeout(() => {
        this.remove();
        this.fadeOut = false;
        window.__dialogNotice = null;
      }, 300);
    },
    handleChangeTab(index) {
      this.tabIndex = index;
    },
    handleChangeTagMenu(item) {
      const tempTabMenuData = this.tabMenuData;
      tempTabMenuData[
        tempTabMenuData.findIndex((child) => child.is_default == 1)
      ].is_default = 0;
      tempTabMenuData[
        tempTabMenuData.findIndex((child) => child == item)
      ].is_default = 1;
      this.$nextTick(() => {
        this.changeContent();
      });
    },
    changeContent() {
      let menuData = this.tabMenuData,
        tempContent = {
          content: "",
        };
      if (menuData && menuData.length > 0) {
        tempContent =
          menuData[menuData.findIndex((child) => child.is_default == 1)];
      }
      if (!tempContent.pic_url) {
        tempContent.content = tempContent.content.replace(
          /<link>(.+)<\/link>/g,
          "<span class='span-link'>$1</span>"
        );
        //文字公告，需要过滤链接
      }
      this.content = tempContent;
    },
    handleJump(content) {
      if (content.jump_url) {
        const url = String(content.jump_url);
        let params;
        if (url.indexOf("?") > -1) {
          params = "&identity=";
        } else {
          params = "?identity=";
        }
        let identity = store.state.app.appInfo.identity;
        openUrl(`${content.jump_url}${params}${identity}`);
      }
    },
    handleTextJump(event, content) {
      if (event.target.nodeName == "SPAN") {
        this.handleJump(content);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.append-box {
  z-index: 88889;
  .dialog-notice-box {
    font-family: Microsoft YaHei;
    position: absolute;
    left: 50%;
    top: 50%;
    display: block;
    z-index: 301;
    color: #ffffff;
    height: 2.925rem;
    width: 5.295rem;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    .ani-dialog-notice-box {
      width: 100%;
      height: 100%;
      background: url(~@/assets/style2/img/act-notice/HD_tc_bg.png) no-repeat;
      background-size: cover;
      font-size: 0.12rem;
      -webkit-animation-duration: 0.3s;
      animation-duration: 0.3s;
      position: relative;
    }

    .title-bg {
      width: 0.99rem;
      height: 0.21rem;
      background: url(~@/assets/img/act-notice/HD_bt_zi.png) no-repeat;
      background-size: cover;
      position: absolute;
      left: 0.23rem;
      top: 0.15rem;
    }
    .title-bg2 {
      width: 5.17rem;
      height: 0.69rem;
      position: absolute;
      left: -0.2rem;
      top: -0.48rem;
    }
    .deng-img {
      width: 1.315rem;
      height: 1.37rem;
      position: absolute;
      left: -0.8rem;
      top: -0.4rem;
    }
    .content-bg {
      width: 4.42rem;
      height: 2.02rem;
      position: absolute;
      left: 50%;
      bottom: 0.18rem;
      transform: translateX(-50%);
    }
    .tag-list {
      position: absolute;
      top: 0.01rem;
      left: 1.5rem;
      .tag-item {
        width: 1.37rem;
        height: 0.325rem;
        display: block;
        float: left;
        font-size: 0.12rem;
        color: #ffffff;
        text-align: center;
        line-height: 0.28rem;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        &.tag-item-act {
          background: url(~@/assets/style2/img/act-notice/UI_ggtanchuang_yqrmhd02_en.png)
            no-repeat;
          background-size: cover;
          &.selected {
            background: url(~@/assets/style2/img/act-notice/UI_ggtanchuang_yq_rmhd01_en.png)
              no-repeat;
            background-size: cover;
            line-height: 0.3rem;
          }
        }
        &.tag-item-notice {
          background: url(~@/assets/style2/img/act-notice/UI_ggtanchuang_yqyxgg02_en.png)
            no-repeat;
          background-size: cover;
          &.selected {
            background: url(~@/assets/style2/img/act-notice/UI_ggtanchuang_yqyxgg01_en.png)
              no-repeat;
            background-size: cover;
            line-height: 0.3rem;
          }
        }
      }
    }
    .tag-menu-box {
      position: absolute;
      left: 0.36rem;
      top: 2.6em;
      width: 1.04rem;
      height: 2.365rem;
      overflow: hidden;
      background: url(~@/assets/style2/img/act-notice/UI_ggtanchuang_yebg.png)
        no-repeat;
      background-size: cover;
      .tag-menu-list {
        .tag-menu-item {
          width: 100%;
          height: 0.33rem;
          line-height: 0.33rem;
          display: block;
          color: #6e4d31;
          text-align: left;
          text-indent: .02rem;
          margin-top: .1rem;
          background: url(~@/assets/style2/img/act-notice/UI_ggtanchuang_ceyq02.png)
            no-repeat;
          background-size: cover;
          &.selected {
            width: 100%;
            height: 0.33rem;
            line-height: 0.33rem;
            background: url(~@/assets/style2/img/act-notice/UI_ggtanchuang_ceyq01.png)
              no-repeat;
            background-size: cover;
            color: #e24635;
          }
        }
      }
    }
    .content-wrapper {
      width: 3.5rem;
      height: 2.2rem;
      position: absolute;
      overflow: hidden;
      display: block;
      left: 1.51rem;
      top: 0.4rem;
      .content {
        font-size: 0.1rem;
        color: #6e4d31;
        width: 100%;
        word-wrap: break-word;
        word-break: break-all;
        img {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }
    }
    .close-pop-message {
      position: absolute;
      right: -0.08rem;
      top: 0rem;
      width: 0.45rem;
      height: 0.45rem;
      background-image: url(~@/assets/style2/img/act-notice/HD_gb_button.png);
    }
  }
}

@media all and (orientation: portrait) {
  .dialog-notice-box {
    transform: translate(-50%, -50%) rotate(90deg) !important;
    -webkit-transform: translate(-50%, -50%) rotate(90deg) !important;
    -moz-transform: translate(-50%, -50%) rotate(90deg) !important;
    -ms-transform: translate(-50%, -50%) rotate(90deg) !important;
    -o-transform: translate(-50%, -50%) rotate(90deg) !important;
  }
}
</style>